<template>
  <Block type="webLogin" class="bg webStoreBg">
    <Block type="bgHuawens" class="bg-huawens"></Block>
    <PwaInstall></PwaInstall>
    <div class="content">
      <HeaderContainer
        class="role-info-contianer relative"
        v-show="serverId && roleId && roleId != -1 && needShowTopRole"
        :class="{ hasVip: hasVip || hasGameCoupon }"
      >
        <span class="server-info">
          {{ letter.creatework_server }} {{ getCurServerName(serverId) }}
        </span>
        <span class="role-info"
          >{{ letter.roleName }}： {{ getCurRoleName(roleId) }}</span
        >
        <blockClickable
          type="reselectRole"
          class="reselect-role j-reselect-role"
          :class="{ hasVip: hasVip || hasGameCoupon }"
          @click="scrollToTop"
          >{{ letter.returnSelectRole }}</blockClickable
        >
        <div class="coupon-info" v-if="hasVip || hasGameCoupon">
          <span class="coupon-info-item" @click="goVipPage" v-if="hasVip">{{
            letter.vipHead
          }}</span>
          <span
            class="coupon-info-item"
            @click="refreshGameCoupon"
            v-if="hasGameCoupon"
            >{{ letter.couponMyQuan }}</span
          >
        </div>
      </HeaderContainer>
      <Block type="loginBox" class="content-box">
        <Icon type="loginBoxLeftTop"></Icon>
        <Icon type="loginBoxRightTop"></Icon>
        <Icon type="loginBoxLeftBottom"></Icon>
        <Icon type="loginBoxRightBottom"></Icon>
        <div class="top-right" v-if="!uidGame">
          <!-- <div style="font-size: 32px;color:#000;float:left" @click="cancelChooseCoupon">取消筛选优惠券</div>
          <div style="font-size: 32px;color:#000;float:left" @click="showCouponPopup = true">我的优惠券</div> -->
          <Select
            type="selectLang"
            icon="selectvh"
            rightSpan="2vh"
            class="select-wrap"
            pointClass="j-select-lang"
            selectClass="j-select-lang-ele"
            v-model="lang"
          >
            <option
              v-for="(text, langVal) in langList"
              :key="langVal"
              :value="langVal"
            >
              {{ text }}
            </option>
          </Select>
          <Button
            type="logoutBtn"
            class="logout"
            pointClassName="j-logout"
            @click="goLogOut"
          >
            {{ letter.logout }}
          </Button>
        </div>
        <i
          class="back j-back-game-list"
          @click="backSelectGame"
          v-show="!showSelectGame && showBack && forwardLinksParam && !fromPwa"
        ></i>

        <!-- <img class="logo" src="../../assets/image/webLogin/logo.png"> -->
        <!-- 第三方储值优化项目：隐藏平台logo -->
        <!-- <img
          class="logo"
          v-if="showLogo"
          :src="logoUrl"
        /> -->
        <Block type="gameSelectBoxStore" class="step-box">
          <v-select-game v-if="showSelectGame"></v-select-game>
          <div v-show="!showSelectGame" class="select-game select-product-box">
            <div class="game-head-logo" v-if="!bannerImg">
              <img :src="gameLogo" v-if="gameLogo" />
            </div>
            <a
              href="javascript:;"
              class="banner"
              @click="jumpToLinkPage(bannerLink)"
              v-if="!!bannerImg"
            >
              <img :src="bannerImg" alt="banner-img" />
            </a>
            <div class="coupon-info" v-if="hasVip || hasGameCoupon">
              <div class="coupon-info-item" @click="goVipPage" v-if="hasVip">
                {{ letter.vipHead }}
              </div>
              <div
                class="coupon-info-item"
                @click="refreshGameCoupon"
                v-if="hasGameCoupon"
              >
                {{ letter.couponMyQuan }}
              </div>
            </div>

            <h3 class="choose-role-title" v-if="uidGame">
              {{ letter.webStoreUidTitle }}
            </h3>
            <!-- 越南大掌柜采用填uid识别账号的方式 -->
            <div class="row uid-input-row" v-if="uidGame">
              <input-comp
                :value="uid"
                :placeholder="letter.webStoreUidInputt"
                @blur="updateUid"
                @focus="cleanProductList"
                class="row-item"
                type="inputStoreInfo"
              ></input-comp>
              <a class="uid-tips row-item" @click="toggleUidGuidePopup(true)">{{
                letter.webStoreUidGuide
              }}</a>
              <div class="uid-guide-popup" v-show="uidGuidePopupState">
                <i
                  class="uid-guide-mask"
                  @click="toggleUidGuidePopup(false)"
                ></i>

                <div class="uid-iframe-box">
                  <a
                    class="uid-guide-popup-close"
                    @click="toggleUidGuidePopup(false)"
                  ></a>
                  <iframe class="uid-iframe" :src="uidGuideUrl"></iframe>
                </div>
              </div>
            </div>
            <h3 class="choose-role-title">{{ letter.selectRole }}</h3>
            <p
              class="pre-store-info"
              v-show="
                lastedGame == gameId && lastedServerId && getCurLastedServerName
              "
            >
              <span
                >{{ letter.previousSelect }}：{{ getCurLastedServerName }} -
                {{ lastedRoleName }}</span
              ><a class="again-role j-again-role" @click="setLastedServerId">{{
                letter.payAgainBtn
              }}</a>
            </p>
            <div class="row" ref="selectRoleInfo">
              <SelectGroup
                type="selectStoreInfo"
                icon="selectvh"
                rightSpan="1.2vh"
                class="row-item"
                pointClass="j-select-server"
                selectClass="j-select-server-ele"
                v-model="serverId"
                @change="loadRole('select_bind')"
              >
                <option value="0" disabled>
                  {{ letter.creatework_serverHolder }}
                </option>
                <optgroup :label="letter.yourServer">
                  <option
                    v-for="item in historyServerList"
                    :key="item.ID"
                    :value="item.ID"
                  >
                    {{ item.NAME }}
                  </option>
                </optgroup>
                <optgroup :label="letter.allServer">
                  <option
                    v-for="item in serverList"
                    :key="item.ID"
                    :value="item.ID"
                  >
                    {{ item.NAME }}
                  </option>
                </optgroup>
              </SelectGroup>
              <Select
                v-if="roleList && roleList.length !== 0"
                type="selectStoreInfo"
                icon="selectvh"
                rightSpan="1.2vh"
                class="row-item"
                pointClass="j-select-role"
                selectClass="j-select-role-ele"
                v-model="roleId"
                @change="loadProduct"
              >
                <option value="-1" disabled>
                  {{ letter.selectRoleName }}
                </option>
                <option
                  v-for="item in roleList"
                  :key="item.roleID"
                  :value="item.roleID"
                >
                  {{ item.roleName }}
                </option>
              </Select>

              <Select
                v-else
                type="selectStoreInfo"
                icon="selectvh"
                rightSpan="1.2vh"
                class="row-item"
                v-model="roleId"
                pointClass="j-select-role"
                selectClass="j-select-role-ele"
                @change="loadProduct"
              >
                <option value="-1" disabled v-if="!serverId">
                  {{ letter.selectRoleName }}
                </option>
                <option value="-1" disabled v-else>
                  {{ letter.creatework_noRole }}
                </option>
              </Select>
            </div>
            <!-- <h1>{{ letter.selectPayment }}</h1> -->
            <v-select-product v-if="!showSelectGame"></v-select-product>
            <!-- 2021-10-12: 因斗罗限购礼包需先登录游戏，故在此添加引导-->
            <div class="row store-tip" v-if="tips1 || tips2">
              <p v-if="tips1" v-html="tips1"></p>
              <p style="color: #999" v-if="tips2" v-html="tips2"></p>
            </div>
            <!-- 越南大掌柜采用填uid识别账号的方式，增加充值提示 -->
            <div class="row store-tip" v-if="uidGame && gameId == 215">
              <h1>Lưu ý</h1>
              <p>
                1. Cấp thân phận đạt cấp 4 sẽ mở giao diện nạp.<br />2. Mua gói
                quà ưu đãi có thể nhận EXP VIP, nhưng không kích hoạt hoạt động
                VIP.(Ví dụ Nạp đầu mỗi ngày,Tích lũy nạp,Tích nạp ngày )<br />3.Nạp
                Nguyên bảo,Gói Phong Nghuyệt,Gói Hoàng Quyền,Bí Quyền Thần
                Tài,Qũy Môn Khách,Quỹ kiếm tiền,Quỹ xx và một số gói hạn giừo 1
                tiếng có thể kích hoạt hoạt đông VIP.(Ví dụ Nạp đầu mỗi
                ngày,Tích lũy nạp,Tích nạp ngày )
              </p>
            </div>
          </div>
        </Block>
      </Block>
    </div>
    <p
      v-if="!gymcGameInVn && !isFuntapVN"
      class="copyright"
      v-html="copyright"
    ></p>
    <div class="link-box">
      <a
        v-if="showCustomize"
        class="customize-link"
        :href="JpServicePrivacy"
        target="_blank"
        >資金決済法に基づく表示</a
      >
      <a
        v-if="showCustomize"
        class="customize-link"
        :href="jpServicePrivacyLink"
        target="_blank"
        >特定商取引法に基づく表示</a
      >
      <a class="service-link" :href="serviceLink" target="_blank">{{
        letter.fwtk
      }}</a>
      <a class="policy-link" :href="privacyLink" target="_blank">{{
        letter.yszc
      }}</a>
      <a
        v-if="paypricyLink && paypricy"
        target="_blank"
        class="policy-link"
        :href="paypricyLink"
        >{{ paypricy }}</a
      >
    </div>

    <div class="slvn-footer" v-if="isFuntapVN">
      <div class="footerInner fixCen pRel" itemscope="">
        <a
          href="https://playfun.vn/"
          title="FunTap"
          class="logo2 pAbs"
          target="_blank"
        >
          <span itemprop="legalName">FunTap</span>
        </a>
        <p class="rs textright">
          <a
            href="https://gabres.slfuntap.com/platform/webSupport.html?gameId=195"
            title="Hỗ Trợ"
            class="bs"
            target="_blank"
          >
            Hỗ Trợ
          </a>
          |
          <a
            href="https://www.slfuntap.com/sea/slvn/list.html?language=vi-VN&ids=325"
            target="_blank"
            class="bs"
          >
            Cài đặt
          </a>
          |
          <a
            href="https://gpassport.slfuntap.com/center/ServicePrivacy/service?gameId=195"
            title="Điều Khoản"
            class="bs"
            target="_blank"
          >
            Điều khoản
          </a>
        </p>
        <p class="rs pd10" itemprop="telephone">Hotline: 1900 636 452</p>
        <p class="rs pd10" itemprop="email">
          Email:
          <a class="bs" href="mailto:Hotro@funtap.vn">Hotro@funtap.vn</a>
        </p>
        <p class="rs" itemprop="name">Bản quyền © 2020 Funtap.</p>
        <p class="rs pd10">
          Thời gian:
          <strong style="color: red">8:00 - 22:00 tất cả các ngày</strong>
          (GMT+7)
        </p>
        <p class="rs">
          Chơi quá 180 phút một ngày sẽ ảnh hưởng xấu đến sức khỏe
        </p>
        <p class="rs">Giấy phép G1 số: 201/GP-BTTTT ngày 14/5/2018</p>
        <p class="rs">Chịu trách nhiệm nội dung: Ông Nguyễn Quang Thịnh</p>
        <p class="rs" itemprop="address">
          <span itemprop="streetAddress">
            Tầng 4 - Tòa nhà Tây Hà - 19 Tố Hữu - Phường Trung Văn - Quận Nam Từ
            Liêm - Hà Nội
          </span>
        </p>
        <div class="ghdt"></div>
      </div>
    </div>
    <transition name="fade">
      <coupon-activity-popup
        v-if="isShowActivityCouponPopup"
        @closeCouponPopup="hideActivityCouponPopup"
        :couponList="activityCouponList"
        :letter="letter"
      ></coupon-activity-popup>
    </transition>
    <transition name="fade">
      <coupon-list-popup
        v-if="isShowGameCouponPopup"
        popupType="game"
        :enableCouponList="gameCouponEnableList"
        :disableCouponList="gameCouponDisableList"
        :expireCouponList="gameCouponExpireList"
        :activeId="gameActiveCouponId"
        :showItemUseBtn="isShowGameItemUseBtn"
        :languages="letter"
        @closeCouponPopup="hideGameCouponPopup"
      ></coupon-list-popup>
    </transition>
    <transition name="fade">
      <coupon-vip-popup
        v-if="isShowVipCouponPopup"
        @closeCouponPopup="hideVipCouponPopup"
        :couponList="vipCouponList"
        :letter="letter"
      ></coupon-vip-popup>
    </transition>
    <transition name="fade">
      <coupon-birth-popup
        v-if="isShowBirthCouponPopup"
        @closeCouponPopup="hideBirthCouponPopup"
        :couponList="birthCouponList"
        :letter="letter"
      ></coupon-birth-popup>
    </transition>
    <transition name="fade">
      <LoaddingPage v-show="loadding"></LoaddingPage>
    </transition>
    <ServiceIconBtn
      v-show="gameId"
      :serverId="getCurSid(serverId)"
      :roleId="roleId"
      :roleName="getCurRoleName(roleId)"
      :gameId="gameId"
    ></ServiceIconBtn>
  </Block>
</template>

<script>
import VSelectGame from '../../components/webStore/SelectGame.vue';
import VSelectProduct from '../../components/webStore/SelectProduct.vue';
import ServiceIconBtn from '../../components/ServiceIcon.vue';
import PwaInstall from '../../components/PwaInstall.vue';
import globalConfig from '../../utiles/globalConfig';
import { getGameLanguage } from '../../store/languages/gameConf';
import {
  UPDATE_GAME_LIST,
  UPDATE_GAMEID,
  SWITCH_LANGUAGE,
  JUDGE_IS_LOGIN,
  GO_BACK_SELECT_GAME,
  GET_SERVER_LIST,
  GET_ROLE_LIST,
  SWITCH_SERVER,
  UPDATE_UID,
  SWITCH_ROLE,
  GET_PRODUCT_LIST,
  UPDATE_LOADING_STATE,
  UPDATE_PRODUCT_LIST,
  UPDATE_PRODUCT_TYPES,
  GO_LOGOUT,
  GET_SEPC_GAME_INFO,
  GET_LASTED_STORE_ROLE
} from '../../store/web/webStore';
import { LANGUAGE_LOCALSTORGE_NAME } from '../../store/languages';
import { INIT_LOGO_BY_IP } from '../../store/logoConfig';
import { CHECK_IP_LOCATION } from '../../store/ipCheck';
import CouponActivityPopup from '../../components/webStore/CouponActivityPopup.vue';
import CouponListPopup from '../../components/webStore/CouponListPopup.vue';
import CouponVipPopup from '../../components/webStore/CouponVipPopup.vue';
import CouponBirthPopup from '../../components/webStore/CouponBirthPopup.vue';
import webStoreCoupon from '../../mixins/webStoreCoupon';
import {
  LOAD_ACTIVITY_COUPON_INFO,
  SET_ACTIVITY_COUPON_SHOW_STATUS
} from '../../store/web/webStoreCoupon';
import { ACTIVITY_COUPON_CONFIG } from '../../store/config/activityCoupon';
import openActivity, { BANNER_ACTIVITY } from '@utiles/openActivity';
import {
  getGlobalGetLinkParams,
  getGlobalGetGotoLink
} from '@utiles/globalGetLink';

import {
  clickButton,
  pageType,
  locationType
} from '@plugins/biPoint/_configSdkstore';
const mainHost = globalConfig.getMainHost();

const mapServerIdBypcServerId = function (pcServerId, serverList) {
  let serverId = '';
  try {
    for (let i = 0; i < serverList.length; i++) {
      if (serverList[i].SID === pcServerId) {
        serverId = serverList[i].ID;
        break;
      }
    }
  } catch (e) {
    serverId = '';
  }
  return serverId;
};

// 跳转banner
const bannerMap = {
  175: {
    'en-US': {
      link: `//pay.${mainHost}/platform/officialWebStore.html?gameId=175#/`,
      img: require('../../assets/image/webStore/banner/gameid_175/en-US.png')
    }
  },
  191: {
    'en-US': {
      link: `//pay.${mainHost}/platform/officialStore.html?gameId=191`,
      img: require('../../assets/image/webStore/banner/gameid_191/en-US.png')
    }
  }
};

export default {
  name: 'webStorePage',
  mixins: [webStoreCoupon],
  beforeCreate() {
    // 2024.07.26 邓智轩：页面链接没有p参数，ip为俄罗斯，页面增加参数p=rupay
    if (!globalConfig.getHrefParam('p')) {
      this.$store.dispatch(CHECK_IP_LOCATION).then(res => {
        if (res.ISO_TWO_CODE == 'RU') {
          const newHref = globalConfig.hrefAddParam(
            window.location.href,
            'p',
            'rupay'
          );
          window.location.href = getGlobalGetGotoLink({ link: newHref });
        }
      });
    }
    /**
     * 邓智轩：20240329：hk&游戏id域名跳转：
     * 1:gameid对，但是域名不对,跳转到对应域名的pay页面
     * 2:域名对，gameid不对,跳转https://www.gnjoy.hk/
     */
    const gameId =
      globalConfig.getHrefParam('gameId') ||
      globalConfig.getHrefParam('game_id');
    const isROV = gameId == 371;
    if (mainHost == 'gnjoy.hk' && gameId && !isROV) {
      window.location.href = getGlobalGetGotoLink({
        link: 'https://gwww.gnjoy.hk/official_website/index.html?name=rorofficial&store=1'
      });
    }
    if (mainHost !== 'gnjoy.hk' && isROV) {
      window.location.href = getGlobalGetGotoLink({
        link: `https://pay.${mainHost}`
      });
    }

    if (
      mainHost == atob('b2RnbGFkc2hlaW1zdHVkaW8uY29t') &&
      !globalConfig.getHrefParam('gameId') &&
      !globalConfig.getHrefParam('game_id')
    ) {
      window.location.href = getGlobalGetGotoLink({
        link: 'https://odgladsheimstudio.com'
      });
      return;
    }

    const preLanguage = globalConfig.getHrefParamUndecode('language');
    if (preLanguage) {
      globalConfig.setLclStorageItem(
        globalConfig.getPageLangStorageKey(),
        preLanguage
      );
    }

    this.$store.dispatch(JUDGE_IS_LOGIN).then(async res => {
      // 泰越斗罗h5：泰国地区域名跳转
      if (mainHost === atob('c2xmdW50YXAuY29t')) {
        this.$store.dispatch(CHECK_IP_LOCATION).then(res => {
          if (res.ISO_TWO_CODE == 'TH') {
            window.location.href = getGlobalGetGotoLink({
              link: window.location.href.replace(
                new RegExp(atob('c2xmdW50YXAuY29t')),
                atob('ZW5kb21haW5uYW1lLmNvbQ==')
              )
            });
          }
          this.$store.dispatch(INIT_LOGO_BY_IP);
        });
      } else {
        this.$store.dispatch(INIT_LOGO_BY_IP);
      }
      const forwardLinksParam =
        sessionStorage.getItem('forwardLinksParam') || ''; // 是否从储值页返回
      let gameId = null;
      let serverId = null;
      let roleId = null;
      //pcServerId 厂商的serverId（简码）。serverId后端的用的server_id（全码）
      let pcServerId =
        globalConfig.getHrefParamUndecode('serverId', forwardLinksParam) ||
        globalConfig.getHrefParam('serverId') ||
        null;
      this.forwardLinksParam = forwardLinksParam;
      gameId =
        globalConfig.getHrefParamUndecode('gameId', forwardLinksParam) ||
        globalConfig.getHrefParam('gameId') ||
        null;
      serverId =
        globalConfig.getHrefParamUndecode('server_id', forwardLinksParam) ||
        globalConfig.getHrefParam('server_id') ||
        null;
      roleId =
        globalConfig.getHrefParamUndecode('roleId', forwardLinksParam) ||
        globalConfig.getHrefParam('roleId') ||
        null;
      if (res) {
        this.$store.dispatch(GET_LASTED_STORE_ROLE);
        // this.$store.dispatch(GET_COUPON_LIST)
        let preGame = gameId || globalConfig.getHrefParamUndecode('gameId');
        if (preGame) {
          const canContinue = await this.$store.dispatch(GET_SEPC_GAME_INFO, {
            gameId: preGame
          });
          if (canContinue === false) {
            globalConfig.jumpErrorPage();
            return;
          }
          this.$store.dispatch(UPDATE_GAMEID, preGame).then(() => {
            if (!this.uidGame || (this.uidGame && this.uid)) {
              this.loadding = true;
              this.$store.dispatch(GET_SERVER_LIST).then(serverList => {
                this.loadding = false;
                if (!serverId && pcServerId) {
                  serverId = mapServerIdBypcServerId(
                    pcServerId,
                    serverList.history
                  ); // 先匹配历史选择过的服务器
                  if (serverId === '') {
                    serverId = mapServerIdBypcServerId(
                      pcServerId,
                      serverList.all
                    ); // 历史中选择过的服务器没有找到才全部搜一遍
                  }
                }
                if (gameId && serverId) {
                  // 如果是储值页返回的，设置默认伺服器、获取角色列表、更新当前角色
                  this.showBack = true;
                  this.serverId = serverId;
                  this.$store
                    .dispatch(GET_ROLE_LIST, serverId)
                    .then(({ roleId }) => {
                      this.roleId = roleId;
                      if (
                        this.roleId != -1 &&
                        this.roleId != null &&
                        this.roleId != undefined
                      ) {
                        window.sdkstoreDataLayer.push({
                          eventName: 'bind',
                          eventValue: {
                            role_id: this.roleId,
                            role_name: this.getCurRoleName(this.roleId),
                            server_id: this.serverId
                          },
                          eventReason: 'auto_bind'
                        });
                        this.$store.dispatch(GET_PRODUCT_LIST);
                      }
                    });
                }
              });
            }
          });
        } else {
          this.loadding = true;
          this.$store.dispatch(UPDATE_GAME_LIST).then(() => {
            this.loadding = false;
          });
        }

        // 权益中心打开时带有showCoupon=1参数直接展示优惠券
        globalConfig.getHrefParam('showCoupon') === '1' &&
          this.refreshGameCoupon();
      } else {
        this.doLogin({
          gameId,
          serverId,
          roleId,
          pcServerId
        });
      }
    });
  },
  created() {
    this.initBannerImg();
  },
  mounted() {
    let _self = this;
    window.addEventListener('scroll', function (e) {
      if (!_self.gameId) return;
      const top =
        _self.$refs.selectRoleInfo.getBoundingClientRect() &&
        _self.$refs.selectRoleInfo.getBoundingClientRect().top;
      _self.needShowTopRole = top < -100;
    });
  },
  data() {
    let gameId =
      globalConfig.getHrefParam('gameId') ||
      globalConfig.getHrefParam('game_id') ||
      globalConfig.getHrefParam('gameID') ||
      '';

    let copyright =
      gameId == 215
        ? `© Copyright Bản quyền thuộc về Sungame Group`
        : `COPYRIGHT © ${location.host.toUpperCase()} ALL RIGHTS RESERVED.`;
    // 2024.07.23 邓智轩：智聪域名的第三方支付页特殊处理
    // 2024.07.26 邓智轩：参数p=rupay时，特殊处理
    if (
      globalConfig.getMainHost() === 'wisdomentertainmen.com' ||
      globalConfig.getHrefParam('p') === 'rupay'
    ) {
      copyright = `COPYRIGHT © 2024 G-CONG NETWORK TECHNOLOGY CO.LIMITED ALL RIGHTS RESERVED.`;
    }
    // 2024.08.01 邓智轩：参数p=wisdom时，特殊处理
    if (
      globalConfig.getMainHost() === window.atob('MzdnYW1lcy5jb20=') &&
      globalConfig.getHrefParam('p') === 'wisdom'
    ) {
      copyright = `COPYRIGHT © WISDOM ENTERTAINMENT ONLINE INTERNATIONAL LIMITED ALL RIGHTS RESERVED.<br>RM 703, 7/F KLN BLDG 555 NATHAN RD KL,Hong Kong,999077`;
    }
    // 2024.08.07 邓智轩：参数p=jppay时，修改页脚主体信息
    if (
      globalConfig.getMainHost() === window.atob('MzdnYW1lcy5jb20=') &&
      globalConfig.getHrefParam('p') === 'jppay'
    ) {
      copyright = `COPYRIGHT © 37ゲームズジャパン株式会社 ALL RIGHTS RESERVED.`;
    }

    let uidGuideUrl =
      gameId == 215
        ? `//sea.${window.atob(
            'MzdnYW1lcy5jb20='
          )}/dcq/news.html?id=5067&language=vi-VN`
        : '';

    return {
      firstLoad: true,
      showBack: true,
      gymcGameInVn: +gameId == 125 || this.$store.state.gameId == 125,
      // 鬼語&越南語 显示 100d品牌
      forwardLinksParam: '',
      copyright: copyright,
      loadding: false,
      uidGuideUrl: uidGuideUrl,
      uidGuidePopupState: false,
      uidGame: globalConfig.isUidGame(),
      needShowTopRole: false,
      bannerImg: '',
      bannerLink: '',
      hasSendCoupon: false,
      fromPwa: globalConfig.getHrefParam('mode') === 'pwa' // pwa打开的话不显示返回按钮
      // showCouponPopup: false
    };
  },
  computed: {
    boolBlancozone() {
      return /blancozone.com/.test(window.location.host);
    },
    JpServicePrivacy() {
      if (+this.gameId === 159) {
        return `//gpassport.${mainHost}/center/JpServicePrivicy/customize?keyWord=dlzj`;
      }
      // 2024.08.07 邓智轩：带参数p=jppay时替换资金结算法链接
      if (
        globalConfig.getMainHost() === window.atob('MzdnYW1lcy5jb20=') &&
        globalConfig.getHrefParam('p') === 'jppay'
      ) {
        return `//gpassport.${window.atob(
          'MzdnYW1lcy5jb20='
        )}/center/JpServicePrivacy/customize?keyWord=ztmslgjppayzj`;
      }
      // 2024.01.23 邓智轩：PNS（191）带参数p=pnsjp时替换资金结算法链接
      if (
        this.$store.state.gameId == 191 &&
        globalConfig.getHrefParam('p') == 'pnsjp'
      ) {
        return `//gpassport.${window.atob(
          'MzdnYW1lcy5jb20='
        )}/center/JpServicePrivacy/customize?keyWord=ztmslgjppayzj`;
      }
      return `//gpassport.${window.atob(
        'MzdnYW1lcy5jb20='
      )}/center/JpServicePrivacy/customize?keyWord=ztmslgzjjsf`;
    },
    lang: {
      get() {
        return this.$store.state.lang;
      },
      set(val) {
        globalConfig.setLclStorageItem(LANGUAGE_LOCALSTORGE_NAME, val);
        this.$store.dispatch(SWITCH_LANGUAGE, val);

        window?.globalUpdateCommonParamsInfo?.({
          language: val
        });
        clickButton({
          btnName: 'select_language',
          locationKey: pageType.homePage
        });
      }
    },
    gameLogo() {
      return this.$store.state.gameLogo;
    },
    isFuntapVN() {
      // const lang =
      //   this.lang ||
      //   globalConfig.getHrefParam("language") ||
      //   globalConfig.getHrefParam("appLanguage");
      return globalConfig.getMainHost() === atob('c2xmdW50YXAuY29t');
    },
    isJp() {
      const iso_two_code =
        localStorage.getItem('locationDetectByIP') &&
        JSON.parse(localStorage.getItem('locationDetectByIP')); // 根据 IP 获取地区码
      const area = iso_two_code && iso_two_code['ISO_TWO_CODE'];
      return area === 'JP' || globalConfig.getLanguages() === 'ja-JP';
    },
    logoUrl() {
      return this.$store.state.logoConfig.webLoginLogo;
    },
    showLogo() {
      return this.$store.state.logoConfig.showWebStoreLogo;
    },
    langList() {
      return this.$store.state.langList;
    },
    showSelectGame() {
      return !this.$store.state.gameId;
    },
    letter() {
      return this.$store.state.letter;
    },
    serverList() {
      return this.$store.state.serverList;
    },
    historyServerList() {
      return this.$store.state.historyServerList;
    },
    roleList() {
      return this.$store.state.roleList;
    },
    gameId() {
      return this.$store.state.gameId;
    },
    uid() {
      return this.$store.state.uid;
    },
    gameList() {
      return this.$store.state.gameList;
    },
    serviceLink() {
      // 2024.08.07 邓智轩：带参数p=jppay时替换服务条款链接
      if (
        globalConfig.getMainHost() === window.atob('MzdnYW1lcy5jb20=') &&
        globalConfig.getHrefParam('p') === 'jppay'
      ) {
        return `//gpassport.${window.atob(
          'MzdnYW1lcy5jb20='
        )}/center/JpServicePrivacy/customize?keyWord=service_pnsjppay`;
      }
      // 2024.08.01 邓智轩：参数p=wisdom时，特殊处理
      if (
        globalConfig.getMainHost() === window.atob('MzdnYW1lcy5jb20=') &&
        globalConfig.getHrefParam('p') === 'wisdom'
      ) {
        return `//gpassport.${window.atob(
          'MzdnYW1lcy5jb20='
        )}/center/ServicePrivacy/customize?keyWord=service_wisdom`;
      }
      // 2024.07.26 邓智轩：参数p=rupay时，特殊处理
      if (globalConfig.getHrefParam('p') === 'rupay') {
        return `//gpassport.${window.atob(
          'MzdnYW1lcy5jb20='
        )}/center/ServicePrivacy/customize?keyWord=service_paycomp`;
      }
      // 2024.07.23 邓智轩：智聪域名的第三方支付页替换服务条款链接
      if (globalConfig.getMainHost() === 'wisdomentertainmen.com') {
        return '//www.gcongnetwork.com/term.html';
      }
      // 2024.01.23 邓智轩：PNS（191）带参数p=pnsjp时替换服务条款链接
      if (
        this.$store.state.gameId == 191 &&
        globalConfig.getHrefParam('p') == 'pnsjp'
      ) {
        return `//gpassport.${window.atob(
          'MzdnYW1lcy5jb20='
        )}/center/JpServicePrivacy/customize?keyWord=service_pnsjppay`;
      }
      return `//gpassport.${globalConfig.getMainHost()}/center/${
        this.isJp ? 'Jp' : ''
      }ServicePrivacy/service`;
    },
    privacyLink() {
      // 2024.08.01 邓智轩：参数p=wisdom时，特殊处理
      if (
        globalConfig.getMainHost() === window.atob('MzdnYW1lcy5jb20=') &&
        globalConfig.getHrefParam('p') === 'wisdom'
      ) {
        return `//gpassport.${window.atob(
          'MzdnYW1lcy5jb20='
        )}/center/ServicePrivacy/customize?keyWord=privacy_wisdom`;
      }
      // 2024.07.26 邓智轩：参数p=rupay时，特殊处理
      if (globalConfig.getHrefParam('p') === 'rupay') {
        return `//gpassport.${window.atob(
          'MzdnYW1lcy5jb20='
        )}/center/ServicePrivacy/customize?keyWord=privacy_paycomp`;
      }
      // 2024.07.23 邓智轩：智聪域名的第三方支付页替换隐私协议链接
      if (globalConfig.getMainHost() === 'wisdomentertainmen.com') {
        return '//www.gcongnetwork.com/privacy.html';
      }
      // 2023.11.15 邓智轩：PNS（191）带参数p=payermax时替换隐私协议
      if (
        this.$store.state.gameId == 191 &&
        globalConfig.getHrefParam('p') == 'payermax'
      ) {
        return `https://gpassport.${window.atob(
          'MzdnYW1lcy5jb20='
        )}/center/ServicePrivacy/customize?keyWord=privacy_paycomp`;
      }
      return `//gpassport.${globalConfig.getMainHost()}/center/${
        this.isJp ? 'Jp' : ''
      }ServicePrivacy/privacy`;
    },
    serverId: {
      get() {
        let sid = this.$store.state.serverId || 0;
        // let match = false;
        if (this.serverList == null) {
          return sid;
        }

        for (let i = 0, len = this.serverList.length; i < len; i++) {
          if (this.serverList[i].SID == this.$store.state.serverId) {
            // match = true;
            sid = this.serverList[i].ID;
            break;
          }
        }

        return sid;
      },
      set(id) {
        this.$store.commit(SWITCH_SERVER, id);
      }
    },
    roleId: {
      get() {
        return this.serverId === 0 ? -1 : this.$store.state.roleId || -1;
      },
      set(id) {
        this.$store.commit(SWITCH_ROLE, id);
      }
    },
    tips1() {
      return getGameLanguage(
        this.$store.state.lang,
        'tips1',
        this.$store.state.gameId
      );
    },
    tips2() {
      return getGameLanguage(
        this.$store.state.lang,
        'tips2',
        this.$store.state.gameId
      );
    },
    paypricy() {
      return getGameLanguage('', 'paypricy', this.$store.state.gameId);
    },
    paypricyLink() {
      return getGameLanguage('', 'paypricyLink', this.$store.state.gameId);
    },
    lastedRoleName() {
      return this.$store.state.lastedRoleName;
    },
    lastedServerName() {
      return this.$store.state.lastedServerName;
    },
    lastedServerId() {
      return this.$store.state.lastedServerId;
    },
    lastedRoleId() {
      return this.$store.state.lastedRoleId;
    },
    lastedGame() {
      return this.$store.state.lastedGame;
    },
    getCurLastedServerName() {
      let res = '';
      if (!this.serverList || this.lastedGame != this.gameId) return res;
      for (let i in this.serverList) {
        if (this.serverList[i].ID == this.lastedServerId) {
          res = this.serverList[i].NAME;
          break;
        }
      }
      return res;
    },
    isShowActivityCouponPopup() {
      return this.$store.state.webStoreCoupon.isShowActivityCouponPopup;
    },
    activityCouponList() {
      return this.$store.state.webStoreCoupon.activityCouponList;
    },
    showCustomize() {
      // 2024.08.07 邓智轩：带参数p=jppay时增加两个日本协议显示
      return (
        (+this.gameId === 191 && this.lang === 'ja-JP') ||
        (+this.gameId === 159 && this.lang === 'ja-JP') ||
        (globalConfig.getMainHost() === window.atob('MzdnYW1lcy5jb20=') &&
          globalConfig.getHrefParam('p') === 'jppay')
      );
    },
    jpServicePrivacyLink() {
      if (+this.gameId === 159) {
        return `//gpassport.${mainHost}/center/JpServicePrivicy/customize?keyWord=business&language=ja&gameId=159`;
      }
      return `//gpassport.${mainHost}/center/JpServicePrivacy/customize?keyWord=payquyin`;
    }
  },
  methods: {
    jumpToLinkPage(link) {
      openActivity(BANNER_ACTIVITY, link, { ...getGlobalGetLinkParams() });
    },
    initBannerImg() {
      try {
        const gameId =
          globalConfig.getHrefParam('gameId') ||
          globalConfig.getHrefParam('game_id') ||
          globalConfig.getHrefParam('gameID') ||
          this.$store.state.gameId ||
          '';
        const banner = bannerMap[+gameId];
        if (!banner) return;
        const item = banner[this.lang] || banner['en-US'] || null;
        if (!item || !item.img || !item.link) return;
        this.bannerImg = item.img;
        this.bannerLink = item.link;
      } catch (e) {
        console.error(e);
        this.bannerImg = '';
        this.bannerLink = '';
      }
    },
    switchLang(lang) {
      this.$store.dispatch(SWITCH_LANGUAGE, lang);
    },
    backSelectGame() {
      this.firstLoad = true;
      this.$store.dispatch(GO_BACK_SELECT_GAME);
      if (!this.gameList.length) {
        this.$store.dispatch(UPDATE_GAME_LIST);
      }
    },
    goLogOut() {
      clickButton({
        btnName: 'logout',
        locationKey: locationType.accountInfo
      });
      this.$store.dispatch(GO_LOGOUT).then(() => {
        let gameId = globalConfig.getHrefParam('gameId');
        if (gameId === '193') {
          window.parent.postMessage(
            {
              action: 'openPageUrl',
              url:
                `https://pay.${mainHost}/platform/login.html?gameId=${gameId}&forward=` +
                encodeURIComponent(
                  getGlobalGetGotoLink({
                    link: `http://gabres.${mainHost}/platform/cloudWebStore.html?gameId=${gameId}`
                  })
                )
            },
            '*'
          );
        }
        this.doLogin({
          gameId: globalConfig.getHrefParam('gameId')
        });
      });
    },
    doLogin({ gameId, serverId, roleId, pcServerId }) {
      let preGame = globalConfig.getHrefParamUndecode('gameId');
      let extendInfo = '';
      if (serverId != undefined) {
        extendInfo += `&server_id=${serverId}`;
      }
      if (pcServerId) {
        extendInfo += `&serverId=${pcServerId}`;
      }
      if (roleId != undefined) {
        extendInfo += `&roleId=${roleId}`;
      }
      // 2024-08-05 邓智轩：添加p=wisdom参数传递，俄罗斯渠道审查页面需要
      // 2021-10-21 添加其他参数传递
      let hrefSearch = window.location.search.substr(1);
      let realHref =
        `https://pay.${mainHost}/platform/login.html` +
        `?${preGame ? `gameId=${preGame}&` : ''}${
          globalConfig.getHrefParam('p')
            ? `p=${globalConfig.getHrefParam('p')}&`
            : ''
        }forward=${encodeURIComponent(
          getGlobalGetGotoLink({
            link: `https://pay.${mainHost}?${
              preGame ? `gameId=${preGame}` : ''
            }${extendInfo ? `${preGame ? '&' : ''}${extendInfo}` : ''}${
              hrefSearch
                ? `${preGame || extendInfo ? '&' : ''}${hrefSearch}`
                : ''
            }`
          })
        )}`;
      window.location.href = getGlobalGetGotoLink({ link: realHref });
    },
    loadRole(selectReason) {
      this.$store
        .dispatch(GET_ROLE_LIST, this.serverId)
        .then(({ loadProductRightNow, roleId }) => {
          if (loadProductRightNow && roleId != null) {
            this.$store.dispatch(GET_PRODUCT_LIST);

            window?.globalUpdateCommonParamsInfo?.({
              roleId: this.roleId,
              roleName: this.getCurRoleName(this.roleId),
              serverId: this.serverId
            });
            window.sdkstoreDataLayer.push({
              eventName: 'bind',
              eventValue: {
                role_id: this.roleId,
                role_name: this.getCurRoleName(this.roleId),
                server_id: this.serverId
              },
              eventReason: selectReason || ''
            });
          }
        });
      this.$store.commit(UPDATE_LOADING_STATE, 0);
      this.$store.commit(UPDATE_PRODUCT_LIST, []);
      this.$store.commit(UPDATE_PRODUCT_TYPES, []);
    },
    loadProduct() {
      if (this.roleId && this.roleId !== -1) {
        this.$store.dispatch(GET_PRODUCT_LIST);
      }
    },
    toggleUidGuidePopup(target) {
      this.uidGuidePopupState = !!target;
    },
    updateUid(id) {
      this.loadding = true;
      let curId = String(id).replace(/[^\d]*/g, '');
      this.$store.dispatch(UPDATE_UID, curId);
      this.$store.commit(SWITCH_SERVER, 0);
      this.$store.dispatch(GET_SERVER_LIST).then(serverList => {
        this.loadRole('auto_bind');
        this.loadding = false;
      });
    },
    cleanProductList() {
      this.$store.commit(UPDATE_LOADING_STATE, 0);
      this.$store.commit(UPDATE_PRODUCT_LIST, []);
      this.$store.commit(UPDATE_PRODUCT_TYPES, []);
    },
    setLastedServerId() {
      clickButton({
        btnName: 'store_again'
      });
      this.serverId = this.lastedServerId;
      this.roleId = this.lastedRoleId;
      this.loadRole('re_stored_bind');
    },
    getCurServerName(id) {
      let res = '';
      if (!this.serverList) return res;
      for (let i in this.serverList) {
        if (this.serverList[i].ID == id) {
          res = this.serverList[i].NAME;
          break;
        }
      }
      return res;
    },
    getCurRoleName(id) {
      let res = '';
      if (!this.roleList) return res;
      for (let i in this.roleList) {
        if (this.roleList[i].roleID == id) {
          res = this.roleList[i].roleName;
          break;
        }
      }
      return res;
    },
    getCurSid(id) {
      let res = id;
      if (!id) return res;
      for (let i in this.serverList) {
        if (this.serverList[i].ID == id) {
          res = this.serverList[i].SID;
          break;
        }
      }
      return res;
    },
    scrollToTop() {
      window.scrollTo({ top: 0 });
    },
    hideActivityCouponPopup() {
      this.$store.commit(SET_ACTIVITY_COUPON_SHOW_STATUS, false);
    }
  },
  components: {
    VSelectGame,
    VSelectProduct,
    ServiceIconBtn,
    CouponActivityPopup,
    CouponListPopup,
    CouponVipPopup,
    CouponBirthPopup,
    PwaInstall
  },
  watch: {
    lang() {
      this.initBannerImg();
    },
    hasGameCoupon: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.loadGameCouponList();
        }
      }
    },
    hasVip: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          if (+this.gameId === 274) {
            if (!this.hasSendCoupon) {
              this.loadVipCouponInfo();
              this.hasSendCoupon = true;
            }
          } else {
            this.loadVipCouponInfo();
          }
          this.hasGameCoupon ? '' : this.loadGameCouponList();
        }
      }
    },
    gameId: {
      immediate: true,
      handler(newVal) {
        if (
          newVal &&
          ACTIVITY_COUPON_CONFIG[newVal] &&
          ACTIVITY_COUPON_CONFIG[newVal].isWebStore
        ) {
          this.$store.dispatch(LOAD_ACTIVITY_COUPON_INFO);
        }
      }
    }
    // serverId() {
    //   this.$store.dispatch(GET_ROLE_LIST, this.serverId)
    //   .then((loadProductRightNow)=>{
    //     if(loadProductRightNow){
    //       this.$store.dispatch(GET_PRODUCT_LIST);
    //     }
    //   });
    //   this.$store.commit(UPDATE_LOADING_STATE, 0);
    //   this.$store.commit(UPDATE_PRODUCT_LIST, []);
    // this.$store.commit(UPDATE_PRODUCT_TYPES, []);
    // },
    // roleId() {
    //   if (this.roleId && this.roleId !== -1) {
    //     this.$store.dispatch(GET_PRODUCT_LIST);
    //   }
    // },
    // roleList(newList){
    //   var match = false;
    //   if(newList!=undefined && newList.length>0){
    //     for(var i =0;i<newList.length;i++){
    //        if(newList[i] === this.roleId){
    //           match = true;
    //        }
    //     }
    //   }
    //   if(!match){
    //     this.roleId = null;
    //   }
    // }
  }
};
</script>

<style lang="scss">
@import '../../assets/scss/platform-webStore.scss';
</style>
<style lang="scss" scoped>
@import '../../assets/scss/comom.scss';
@import '../../assets/scss/base.scss';
@import '../../assets/scss/webStore.scss';
.bg {
  background-repeat: no-repeat;
  display: block;
  float: left;
  width: 100%;
  text-align: center;
  position: relative;
  min-height: 100%;
  &.webStoreBg {
    height: initial;
  }
}
.web-store {
  background: url($imgSupport + 'bg.jpg') no-repeat center center;
  background-size: cover;
  width: 100%;
  height: 100%;
  min-height: 100%;
  text-align: center;
  position: relative;
}

.content {
  min-height: 84vh;
  position: relative;
}

.content-box {
  margin: 10.7vh auto 6vh;
  background: white;
  text-align: center;
  padding: 3.6vh 2vh 3vh;
  display: inline-block;
  font-size: 0;
  position: relative;
}

.logo {
  max-width: 50%;
  width: 25.8vh;
  margin: 0;
  display: inline-block;
}

.choose-role-title {
  color: $font;
  margin-bottom: 2vh;
  font-size: 2.3vh;
  font-family: 'SourceHanSansSC Bold';
  font-weight: bold;
}
.row,
.banner {
  width: 80vw;
}
.row-item {
  box-sizing: border-box;
  display: inline-block;
  vertical-align: top;
  font-size: 1.8vh;
  font-family: 'Adobe Heiti Std';
  color: #666;
  position: relative;
  width: 100%;
  .row-title {
    position: absolute;
    width: 100%;
    height: 5.6vh;
    line-height: 5.6vh;
    left: 0.9vh;
    top: 0;
  }
}

.choose-server,
.choose-role {
  display: inline-block;
  margin: 0 auto 2vh;
  height: 4.2vh;
  background: white;
  font-size: 1.8vh;
  font-family: 'Adobe Heiti Std';
  color: #666;
  padding-left: 1vh;
}

.step-box {
  margin-top: 2.7vh;
  background: $grey;
  padding: 2vh 1vh 4.6vh;
  text-align: left;
  position: relative;
  transition: all 0.6s;
  box-sizing: border-box;
}

.copyright {
  color: #6e706f;
  text-align: center;
  margin-bottom: 1vh;
  font-size: 1.6vh;
  -webkit-text-size-adjust: none;
}

.link-box {
  text-align: center;
  margin-bottom: 40px;
  position: relative;
}

.customize-link,
.service-link,
.policy-link {
  display: inline-block;
  margin: 0 10px;
  font-size: 1.6vh;
  color: #6e706f;
  text-align: center;
  text-decoration: none;
  -webkit-text-size-adjust: none;
}

.back {
  background: url($imgSupport + 'back.png') no-repeat center center;
  background-size: contain;
  width: 2.2vh;
  height: 2.2vh;
  position: absolute;
  top: -5.4vh;
  left: 0;
  /*!rtl:raw:
    transform: scaleX(-1);
  */

  &:hover {
    cursor: pointer;
  }
}

.top-right {
  position: absolute;
  top: -6vh;
  right: 0;
  min-width: 70vw;
  text-align: right;
}
.select-wrap {
  display: inline-block;
  position: relative;
  width: 16.3vh;
  min-width: 24%;
  height: 4vh;
  padding-left: 2vh;
  margin-right: 1vh;
  line-height: 4vh;
  font-size: 1.8vh;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.6);
  border: 1px solid white;
  cursor: pointer;
}
.select {
  position: absolute;
  top: 0;
  left: 0;
  outline: none;
  width: 100%;
  height: 100%;
  line-height: 4vh;
  font-size: 1.8vh;
  padding-left: 2vh;
  color: $fontgrey;
  display: block;
  background: transparent;
  border: none;
  z-index: 1;
  cursor: pointer;
}

.logout {
  outline: none;
  min-width: 4.3vh;
  height: 4vh;
  line-height: 4vh;
  text-align: center;
  font-size: 1.8vh;
  color: $fontgrey;
  padding: 0 1vh;
  background: rgba(255, 255, 255, 0.6);
  border: 1px solid white;
  display: inline-block;
  cursor: pointer;
  vertical-align: top;
}

.list {
  position: absolute;
  font-size: 0;
}

.tra,
.tra-s {
  background: url($imgSupport + 'tra.png') no-repeat center center;
  background-size: contain;
  position: absolute;
  width: 1.4vh;
  height: 1vh;
  top: -4.4vh;
  right: 9vh;
}
.top-right {
  .tra {
    top: 1.5vh;
    right: 2vh;
  }
}
.tra-s {
  top: 1.4vh;
  right: 1vh;
}
.uid-input-row {
  position: relative;
}

.uid-tips {
  color: #f65353;
  display: inline-block;
  font-size: 1.6vh;
  line-height: 4.2vh;

  &:hover {
    cursor: pointer;
  }
}
.uid-guide-popup {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 10;
  .uid-guide-mask {
    background: rgba(0, 0, 0, 0.6);
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: -1;
    position: absolute;
    cursor: pointer;
  }
  .uid-iframe-box {
    width: 64vw;
    height: 64vh;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -32vh;
    margin-left: -32vw;
    padding: 4vh 3vh;
    background: white;
    box-sizing: border-box;
  }
  iframe {
    width: 100%;
    height: 100%;
  }
  &-close {
    $size: 2.4vh;
    position: absolute;
    background: url('../../assets/image/icons/popup-close.png') center no-repeat;
    background-size: contain;
    width: $size;
    height: $size;
    top: 1vh;
    right: 1vh;
    z-index: 11;
    &:hover {
      cursor: pointer;
    }
  }
}
@media screen and (orientation: landscape) {
  .choose-server,
  .choose-role {
    height: 6vh;
  }
  .tra-s {
    top: 2.4vh;
    right: 1vh;
  }
  .row-item {
    width: 24.5vw !important;
    &:nth-child(2) {
      margin-left: 1vw !important;
    }
  }
  .row,
  .banner {
    width: 50vw;
  }
  .step-box {
    padding: 2vh 3.6vh 4.6vh;
  }
  .content-box {
    padding: 3.6vh 3vh 3vh;
  }
  .top-right {
    min-width: 50vw;
  }
}

.slvn-footer {
  display: block;
  height: auto;
  width: 100%;
  padding: 40px 0 30px;
  text-align: center;
  color: #fff;
  background: #181818;
  box-sizing: border-box;
  .fixCen {
    width: 100%;
    margin: 0 auto;
    position: relative;
    height: 100%;
  }
  .footerInner {
    color: #fff;
    font-size: 13px;
    text-align: center;
    position: relative;
    margin: 0 auto;
  }
  .footerInner a.bs {
    color: #fff;
    display: inline-block;
    margin: 0 10px;
  }
  .logo2 {
    display: block;
    text-indent: -999em;
    background: url($imgWebStore + 'logo-slvn.png') 0 0 no-repeat;
    width: 149px;
    height: 41px;
    left: 0;
    top: -10px;
  }
  .pAbs {
    position: absolute;
  }
  .footerInner p {
    margin-bottom: 6px;
  }
  .ghdt {
    position: absolute;
    right: 0;
    top: 0;
    width: 60px;
    height: 86px;
    background: url($imgWebStore + '18t.png') no-repeat center top;
    background-size: 100%;
  }
  img {
    vertical-align: middle;
    border-style: none;
  }
}

@media screen and (orientation: portrait) {
  .slvn-footer {
    display: block;
    width: 100%;
    // height: 40vh;
    padding: 40px 0 30px;
    text-align: center;
    color: #fff;
    background: #181818;
    box-sizing: border-box;
    .footerInner {
      color: #fff;
      font-size: 20px;
    }
    .fixCen {
      margin: 0 auto;
      position: relative;
      height: 100%;
    }
    .logo2 {
      position: inherit;
      top: 0;
      margin: 0 auto 10px;
      display: block;
      text-indent: -999em;
      background: url($imgWebStore + 'logo-slvn.png') 0 0 no-repeat;
      width: 149px;
      height: 41px;
      left: 0;
      top: -10px;
    }
    .footerInner a.bs {
      color: #fff;
      display: inline-block;
      margin: 0 10px;
    }
    .footerInner p {
      margin-bottom: 5px;
      padding: 0;
    }
    .ghdt {
      width: 60px;
      height: 86px;
      background: url($imgWebStore + '18t.png') no-repeat center top;
      background-size: 100%;
      position: initial;
      display: block;
      margin: 1vh auto 0;
    }
  }
  .uid-input-row {
    .row-item:nth-child(2) {
      margin-top: -1vh;
    }
  }
  .uid-guide-popup {
    .uid-iframe-box {
      width: 90vw;
      height: 80vh;
      margin-top: -40vh;
      margin-left: -45vw;
    }
  }
  .role-info-contianer {
    height: 110px;
    &.hasVip {
      height: 175px;
    }
    .server-info,
    .role-info,
    .coupon-info {
      display: block;
      line-height: 50px;
      height: 50px;
      width: auto;
      padding-left: 35px;
      max-width: auto;
    }
    .coupon-info {
      float: unset !important;
      display: flex;
      font-size: 22px;
      padding-right: 35px;
      &-item {
        flex-grow: 1;
        text-align: center;
        line-height: 40px;
        height: 40px;
        padding: 0 20px;
      }
    }
    .reselect-role {
      float: unset !important;
      position: absolute;
      top: 50%;
      right: 42px;
      transform: translateY(-50%);
      &.hasVip {
        top: 22px;
        right: 42px;
        transform: none;
      }
    }
  }
}

.store-tip {
  margin-top: 2vh;
  h1 {
    font-size: 2.4vh;
  }
  p {
    font-size: 1.6vh;
    line-height: 150%;
  }
}

.bg-huawens {
  position: absolute;
}
.pre-store-info {
  font-size: 1.6vh;
  line-height: 2vh;
  height: 2vh;
  color: #666;
  position: relative;
  margin: -1vh auto 1vh;
  .again-role {
    line-height: 2vh;
    height: 2vh;
    color: $green;
    text-decoration: underline;
    padding-left: 1vh;
    &:hover {
      cursor: pointer;
    }
  }
}

.coupon-info {
  display: flex;
  width: 100%;
  &-item {
    display: inline-block;
    font-size: 1.8vh;
    margin: 10px 5px;
    flex-grow: 1;
    text-align: center;
    line-height: 4.2vh;
    height: 4.2vh;
    padding: 0 20px;
    border: 1px solid #5fd193;
    color: #5fd193;
    cursor: pointer;
    box-sizing: border-box;
  }
}
</style>
